
  $(document).ready(function(){

    var $container = $('#container'),
        filters = {};

    $container.isotope({
      itemSelector : '.grid-item',
      columnWidth: '.grid-item',
      layoutMode : 'fitRows',
      resizesContainer:true,
			//percentPosition: false
      // straightDown: {
      //   rowHeight: 500,
      //   rowWidth: 500,
      // },

    });

    // filter buttons
    $('.filter a').click(function(){
      var $this = $(this);
      // don't proceed if already selected
      if ( $this.hasClass('selected') ) {
        return;
      }

      var $optionSet = $this.parents('.option-set');
      // change selected class
      $optionSet.find('.selected').removeClass('selected');
      $this.addClass('selected');

      // store filter value in object
      // i.e. filters.color = 'red'
      var group = $optionSet.attr('data-filter-group');
      filters[ group ] = $this.attr('data-filter-value');
      // convert object into array
      var isoFilters = [];
      for ( var prop in filters ) {
        isoFilters.push( filters[ prop ] )
      }
      var selector = isoFilters.join('');
      $container.isotope({ filter: selector });
      return false;
    });
    if ( !$container.data('isotope').filteredItems.length ) {
        $container.html('<h3>Désolé, aucun produit en ce moment</h3>')
    }
    $container.on( 'arrangeComplete', function( event, filteredItems ) {
          var resultCount = filteredItems.length;
          if(resultCount == 0) {
            alertify.set({ delay: 1500 });
            alertify.error("Aucun produit dans la catégorie");
          }
      });

  });
